import type { RootState } from '../index';

export const getIsOnline = (state: RootState) => state.connectionState.isOnline;
export const getLastChecked = (state: RootState) =>
  state.connectionState.lastChecked;
